import { Box, Button, Typography } from '@mui/material'
import { OpenInNewOffOutlined } from '@mui/icons-material'
import { formatDate, refreshS3SignedUrl } from '../../../helpers/UtilityHelper'
import { NAVY, SUBTLE, BORDER, PRIMARY_BLUE } from '../../../styles/foundation/colors'
import { FONT, SIZE, WEIGHT } from '../../../styles/foundation/typography'

function Pods({ id }) {
  const data = id?.pods || []

  const handleView = async (url) => {
    const refreshedUrl = await refreshS3SignedUrl(url)
    window.open(refreshedUrl, '_blank')
  }

  if (!data.length) return null

  return (
    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
      {data.map((pod, index) => (
        <Box
          key={index}
          sx={{
            border: `1px solid ${BORDER}`,
            borderRadius: '10px',
            p: 2,
            minWidth: 160,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <Typography
            sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], fontWeight: WEIGHT.semibold, color: NAVY }}
          >
            POD #{index + 1}
          </Typography>
          <Typography sx={{ fontFamily: FONT, fontSize: '0.68rem', color: SUBTLE }}>
            {pod.podDateTime ? formatDate(pod.podDateTime) : '\u2014'}
          </Typography>
          <Button
            variant='outlined'
            size='small'
            startIcon={<OpenInNewOffOutlined sx={{ fontSize: 14 }} />}
            onClick={() => handleView(pod.preSignedUrl)}
            sx={{
              fontFamily: FONT,
              fontSize: SIZE['2xs'],
              fontWeight: WEIGHT.semibold,
              textTransform: 'none',
              borderColor: BORDER,
              color: PRIMARY_BLUE,
              '&:hover': { borderColor: PRIMARY_BLUE },
            }}
          >
            View
          </Button>
        </Box>
      ))}
    </Box>
  )
}

export default Pods
